import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import contractSlice from "./contract/ContractReducer";
import sessionSlice from "./session/SessionReducer";

import productSlice from "./product/product/ProductReducer";
import productBOMSlice from "./product/productBOM/ProductBOMReducer";
import processStepSlice from "./process/processStep/ProcessStepReducer";

import processSlice from "./process/process/ProcessReducer";
import processBOMSlice from "./process/processbom/ProcessBOMReducer";
import materialSlice from "./material/material/MaterialReducer";
import materialInSlice from "./material/materialIn/MaterialInReducer";
import materialOutSlice from "./material/materialOut/MaterialOutReducer";

import productStockManagementSlice from "./product/productStockManagement/ProductStockManagementReducer";
import productInSlice from "./product/productIn/ProductInReducer";
import productOutSlice from "./product/productout/ProductOutReducer";

import partnerSlice from "./partner/partner/PartnerReducer";
import partnerManagerSlice from "./partner/partnermanager/PartnerManagerReducer";
import machineSlice from "./machine/MachineReducer";
import loadingSlice from "./loading/LoadingReducer";
import productionSlice from "./prodcution/production/ProdcutionReducer";
import progressSlice from "./progress/ProgressReducer";
import fileSlice from "./file/FileReducer";
import kpiSlice from "./kpi/KPIReducer";
import storageSlice from "./storage/StorageReducer";

import { fileService } from "../api/file/fileService";
import { KPIService } from "../api/kpi/KPIService";
const store = configureStore({
    reducer:{
        session: sessionSlice,
        contract: contractSlice,
        product: productSlice,
        processStep: processStepSlice,
        productBOM: productBOMSlice,
        process: processSlice,
        processBOM: processBOMSlice,
        material: materialSlice,
        materialIn: materialInSlice,
        materialOut: materialOutSlice,
        productStockManageManagement: productStockManagementSlice,
        productIn: productInSlice,
        productOut: productOutSlice,
        partner: partnerSlice,
        partnerManager: partnerManagerSlice,
        machine: machineSlice,
        loading: loadingSlice,
        production: productionSlice,
        progress: progressSlice,
        file: fileSlice,
        kpi: kpiSlice,
        storage: storageSlice
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            thunk: { extraArgument: { fileService, KPIService } },
        serializableCheck: false,
    }),
})


export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;
export default store;